(() => {
  if (window.sncEuNoticeInstalled) return;
  window.sncEuNoticeInstalled = true;
  let opener, previousOverflow, width = 1, fitWidth = 1;
  const dialog = document.getElementById('snc-eu-document');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const viewport = dialog.querySelector('.snc-eu-document__viewport');
  const image = dialog.querySelector('img');
  const zoomButtons = dialog.querySelectorAll('[data-snc-eu-zoom]');
  function setWidth(next) {
    const old = width;
    width = Math.max(fitWidth, Math.min(1536, next));
    image.style.setProperty('--snc-eu-width', `${width}px`);
    viewport.scrollLeft *= width / old;
    viewport.scrollTop *= width / old;
    zoomButtons.forEach(button => {
      button.disabled = Number(button.dataset.sncEuZoom) < 0 ? width === fitWidth : width === 1536;
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-snc-eu-open]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = link;
    if (!image.src) image.src = image.dataset.src;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    fitWidth = Math.floor(Math.min(viewport.clientWidth - 24, (viewport.clientHeight - 24) * 595.28 / 841.89));
    setWidth(fitWidth);
    viewport.scrollTo(0, 0);
  });
  dialog.querySelector('[data-snc-eu-close]').addEventListener('click', () => dialog.close());
  zoomButtons.forEach(button => button.addEventListener('click', () => setWidth(width + Number(button.dataset.sncEuZoom) * 256)));
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    opener?.focus({ preventScroll: true });
  });
})();
